import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import SingleFileUploadContainer from '../../upload/addFilesDialog.component'
import DownloadContainer from './download.container';
import DeleteSessionButtonContainer from './deleteSessionButton.container';
import ChangeSessionName from './changeSessionName.component';
import { Button, Icon } from '@material-ui/core';

const styles = theme => ({
  actionButton: {
    position: 'relative',
    float: 'right',
    zIndex: '10',
    height: '64px',
    width: '50px',
    margin: '0 0 -6px 0',
    textAlign: 'center',
    lineHeight: '60px',
  },
  white:{
    color: 'white',
    fontSize: '28px',
    fontWeight: 'bold'
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
  hideSession: {
    float: 'right',
  },
});

class SessionActionButton extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.hideSession = this.hideSession.bind(this)
    this.state = {
      anchorEl: null,
    };
  }

  handleClick(e) {

    this.setState({ anchorEl: e.currentTarget });
  }

  handleClose() {
    this.setState({ anchorEl: null });
  }

  hideSession() {

    this.props.hideSession();
    return this.handleClose();
  }

  render() {
    const { session, classes } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <div className={classes.actionButton}>
        <IconButton
          aria-label="More"
          aria-owns={open ? 'session-action-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}

        >
          <MoreVertIcon  className={this.props.white?classes.white:''}/>
        </IconButton>
        <Menu
          id="session-action-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
        >
          <MenuItem key="update-session-name">
            <ChangeSessionName
              close={this.toggleEditNameActive}
              session={session}
              callback={this.handleClose}
            />
          </MenuItem>
          <MenuItem key="add-file-to-session">
            <SingleFileUploadContainer
              sessionId={session.id}
              callback={this.handleClose}
            />
          </MenuItem>
          <MenuItem key="save-as-template">
            <DownloadContainer
              sessionId={session.id}
              type="templateFile"
              icon="save_alt"
              buttonText="Save As Template"
              callback={this.handleClose}
            />
          </MenuItem>
          <MenuItem key="download-conversion-zip">
            <DownloadContainer
              sessionId={session.id}
              type="conversionZip"
              buttonText="Conversion zip"
              callback={this.handleClose}
            />
          </MenuItem>
          <MenuItem key="download-attribute-zip">
            <DownloadContainer
              sessionId={session.id}
              type="attributeZip"
              buttonText="Attribute zip"
              callback={this.handleClose}
            />
          </MenuItem>
          <MenuItem key="download-mapping-zip">
            <DownloadContainer
              sessionId={session.id}
              type="mappingZip"
              buttonText="Mapping zip"
              callback={this.handleClose}
            />
          </MenuItem>
          <MenuItem key="delete-session">
            <DeleteSessionButtonContainer
              sessionId={session.id}
              label="Delete project"
              callback={this.handleClose}
            />
          </MenuItem>
          <MenuItem key="hide-session"  >

          <Button
            className={classes.hideSession}
            color="primary"
            onClick={()=> {this.hideSession()}}
           >
                <Icon className={classes.icon}>
              visibility
            </Icon>
            {this.props.hide? 'un': ''}hide session
          </Button>
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

SessionActionButton.propTypes = {
  session: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  hideSession: PropTypes.func.isRequired,
  hide: PropTypes.bool,
  /* eslint-enable */
};

export default withStyles(styles)(SessionActionButton);
